import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { JWT } from '../constants/local_storage'
import { clearJwtAndRedirectToLogin, isJwtExpired } from '../utils/jwtExpiry'

axios.interceptors.request.use(
  function (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    const token = localStorage.getItem(JWT)
    if (token && isJwtExpired(token)) {
      clearJwtAndRedirectToLogin()
      throw new Error('JWT expired')
    }
    config.headers['Authorization'] = `Bearer ${token}`
    config.headers['Content-Type'] = `application/json`
    return config
  },
  function (error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error)
  }
)

export default axios
